export { PaginationComponent } from './components';
export { PaginationModule } from './ngx-pagination-bootstrap.module';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/index.ts